import { createStore } from 'vuex'
import comments from '../comments/store'
import defaultState from './state'
import buildState from './build-state'
import getters from './getters'
import mutations from './mutations'
import actions from './actions'

let store

export default function buildStore(componentName) {
  const state = buildState(componentName, defaultState)
  store = createStore({
    state,
    getters,
    mutations,
    actions,

    modules: {
      comments
    }
  })

  return store
}
